var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"steps"},_vm._l((_vm.list),function(item,index){return _c('div',{key:item.id,staticClass:"steps__item",class:{ 'm-active': item.id === _vm.active }},[_vm._v(" "+_vm._s(index + 1)+". "+_vm._s(item.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }